import config from 'baseConfig/pg/v2/disputes';
import {
  ACTION_REQUIRED,
  UNDER_REVIEW,
  CLOSED,
  ALL_DISPUTES,
} from 'baseConfig/pg/v2/constants';

export default {
  [ACTION_REQUIRED]: {
    TABLE_COLUMNS: [
      {
        key: 'disputeId',
        displayName: 'Dispute ID',
        tooltip: {
          message: 'Unique Dispute Identifier',
        },
        width: 1.1,
      },
      {
        key: 'disputeAmt',
        displayName: 'Dispute Amount',
        align: 'center',
        tooltip: {
          message: 'Dispute Amount',
        },
        width: 1.4,
      },
      {
        key: 'type',
        displayName: 'Dispute Type',
        tooltip: {
          message: 'Type of Dispute',
        },
        width: 1.3,
      },
      {
        key: 'createdOn',
        displayName: 'Created On',
        align: 'left',
        tooltip: {
          message: 'Dispute Created On',
        },
        width: 1.3,
      },
      {
        key: 'updatedOn',
        displayName: 'Updated On',
        align: 'left',
        tooltip: {
          message: 'Dispute Last Updated On',
        },
        width: 1.3,
      },
      {
        key: 'respondBy',
        displayName: 'Respond By',
        align: 'left',
        tooltip: {
          message: 'Deadline to Respond to Dispute',
        },
        width: 1.3,
      },
      {
        key: 'orderId',
        displayName: 'Order ID',
        tooltip: {
          message: 'Associated Order ID',
        },
        // width: 2.4
      },
      {
        key: 'transactionId',
        displayName: 'Transaction ID',
        tooltip: {
          message: 'Associated Transaction ID',
        },
      },
      {
        key: 'action',
        displayName: 'Action',
        align: 'center',
      },
    ],
    FILTER_ITEMS: config[ACTION_REQUIRED].FILTER_ITEMS,
    SEARCH_ITEMS: [...config[ACTION_REQUIRED].SEARCH_ITEMS],
  },
  [UNDER_REVIEW]: {
    TABLE_COLUMNS: [
      {
        key: 'disputeId',
        displayName: 'Dispute ID',
        tooltip: {
          message: 'Unique Dispute Identifier',
        },
        width: 1.1,
      },
      {
        key: 'disputeAmt',
        displayName: 'Dispute Amount',
        align: 'center',
        tooltip: {
          message: 'Dispute Amount',
        },
        width: 1.4,
      },
      {
        key: 'type',
        displayName: 'Dispute Type',
        tooltip: {
          message: 'Type of Dispute',
        },
        width: 1.3,
      },
      {
        key: 'createdOn',
        displayName: 'Created On',
        align: 'left',
        tooltip: {
          message: 'Dispute Created On',
        },
        width: 1.3,
      },
      {
        key: 'updatedOn',
        displayName: 'Updated On',
        align: 'left',
        tooltip: {
          message: 'Dispute Last Updated On',
        },
        width: 1.3,
      },
      {
        key: 'respondBy',
        displayName: 'Respond By',
        align: 'left',
        tooltip: {
          message: 'Deadline to Respond to Dispute',
        },
        width: 1.3,
      },
      {
        key: 'orderId',
        displayName: 'Order ID',
        tooltip: {
          message: 'Associated Order ID',
        },
        // width: 2.4
      },
      {
        key: 'transactionId',
        displayName: 'Transaction ID',
        tooltip: {
          message: 'Associated Transaction ID',
        },
      },
      {
        key: 'underReviewIcon',
        displayName: '',
        align: 'right',
      },
    ],
    FILTER_ITEMS: config[UNDER_REVIEW].FILTER_ITEMS,
    SEARCH_ITEMS: [...config[UNDER_REVIEW].SEARCH_ITEMS],
  },
  [CLOSED]: {
    TABLE_COLUMNS: [
      {
        key: 'disputeId',
        displayName: 'Dispute ID',
        tooltip: {
          message: 'Unique Dispute Identifier',
        },
        width: 1.1,
      },
      {
        key: 'disputeAmt',
        displayName: 'Dispute Amount',
        align: 'center',
        tooltip: {
          message: 'Dispute Amount',
        },
        width: 1.4,
      },
      {
        key: 'type',
        displayName: 'Dispute Type',
        tooltip: {
          message: 'Type of Dispute',
        },
        width: 1.3,
      },
      {
        key: 'createdOn',
        displayName: 'Created On',
        align: 'left',
        tooltip: {
          message: 'Dispute Created On',
        },
        width: 1.3,
      },
      {
        key: 'updatedOn',
        displayName: 'Updated On',
        align: 'left',
        tooltip: {
          message: 'Dispute Last Updated On',
        },
        width: 1.3,
      },
      {
        key: 'respondBy',
        displayName: 'Respond By',
        align: 'left',
        tooltip: {
          message: 'Deadline to Respond to Dispute',
        },
        width: 1.3,
      },
      {
        key: 'orderId',
        displayName: 'Order ID',
        tooltip: {
          message: 'Associated Order ID',
        },
        // width: 2.4
      },
      {
        key: 'transactionId',
        displayName: 'Transaction ID',
        tooltip: {
          message: 'Associated Transaction ID',
        },
      },
      {
        key: 'action',
        displayName: 'Action',
        align: 'center',
      },
    ],
    FILTER_ITEMS: config[CLOSED].FILTER_ITEMS,
    SEARCH_ITEMS: [...config[CLOSED].SEARCH_ITEMS],
  },
  [ALL_DISPUTES]: {
    TABLE_COLUMNS: [
      {
        key: 'disputeId',
        displayName: 'Dispute ID',
        tooltip: {
          message: 'Unique Dispute Identifier',
        },
        width: 1.1,
      },
      {
        key: 'disputeAmt',
        displayName: 'Dispute Amount',
        align: 'center',
        tooltip: {
          message: 'Dispute Amount',
        },
        width: 1.4,
      },
      {
        key: 'type',
        displayName: 'Dispute Type',
        tooltip: {
          message: 'Type of Dispute',
        },
        width: 1.3,
      },
      {
        key: 'createdOn',
        displayName: 'Created On',
        align: 'left',
        tooltip: {
          message: 'Dispute Created On',
        },
        width: 1.3,
      },
      {
        key: 'updatedOn',
        displayName: 'Updated On',
        align: 'left',
        tooltip: {
          message: 'Dispute Last Updated On',
        },
        width: 1.3,
      },
      {
        key: 'respondBy',
        displayName: 'Respond By',
        align: 'left',
        tooltip: {
          message: 'Deadline to Respond to Dispute',
        },
        width: 1.3,
      },
      {
        key: 'orderId',
        displayName: 'Order ID',
        tooltip: {
          message: 'Associated Order ID',
        },
        // width: 2.4
      },
      {
        key: 'transactionId',
        displayName: 'Transaction ID',
        tooltip: {
          message: 'Associated Transaction ID',
        },
      },
      {
        key: 'action',
        displayName: 'Action',
        align: 'center',
      },
    ],
    FILTER_ITEMS: config[ALL_DISPUTES].FILTER_ITEMS,
    SEARCH_ITEMS: [...config[ALL_DISPUTES].SEARCH_ITEMS],
  },
};
